<template>
    <div class="check">
        <div class="warning">
            <p>
                КриптоПро ЭЦП Browser plug-in не обнаружил ни одной ЭЦП.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>

</style>